import { useServiceFeatures } from 'hooks/useServiceContext';

export function useIs3DVisualisationEnabled(): boolean {
  const { quickQuoteConfig } = useServiceFeatures();

  return quickQuoteConfig?.is3DVisualisationEnabled ?? false;
}

export function useIsSideLoadingEnabled(): boolean {
  const { quickQuoteConfig } = useServiceFeatures();

  return quickQuoteConfig?.isSideLoadingEnabled ?? false;
}
